module.exports = __webpack_public_path__ + "static/media/product-service-banner1.aaee7786.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/productService/images/product-service-banner1.jpg
// module id = 150
// module chunks = 0